<div class="app-mian-header" [ngClass]="fixedTab ? 'fixed_header':''">
  <div class="header-inner">
    <div class="header-part-left">
      <div class="logo-header">
        <a [routerLink]="['/admin/dashboard']" (click)="changeActiveRoute('header.home')">
          <img src="./assets/images/logo/logo.png">
        </a>
      </div>
      <div class="dropdown-container m-0" appDropDown>
        <div class="dropdown-toggler">
          {{activeLink}}
        </div>

        <div class="dropdown-inner-menu not-before dropdowm_menu_left">
          <div class="dropdown_item">
            <a [routerLink]="['/admin/dashboard']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.home')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe070;"></span>
              {{ 'header.home' | translate }}
            </a>
          </div>
          <!-- <div class="dropdown_item" appAccessControl [accessRoles]="actions.MyTasksList">
            <a [routerLink]="['/admin/task']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.my_tasks')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.my_tasks' | translate }}
            </a>
          </div> -->
          <!-- <div class="dropdown_item" appAccessControl [accessRoles]="actions.MyInbox">
            <a [routerLink]="['/admin/MyInbox']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.my_inbox')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{'header.my_inbox' | translate }}
            </a>
          </div> -->

          <div class="dropdown_item" appAccessControl [accessRoles]="actions.InboundOperations">
            <a [routerLink]="['/admin/inbound']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.inbound')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.inbound' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.OutboundOperations">
            <a [routerLink]="['/admin/outbound']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.outbound')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.outbound' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.DistributionManagement">
            <a [routerLink]="['/admin/distribution-management']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.distribution_management')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.distribution_management' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.InventoryOperations">
            <a [routerLink]="['/admin/inventory']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.inventory')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.inventory' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.BusinessCenterList">
            <a [routerLink]="['/admin/business-insights']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.business_insights')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.business_insights' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.HumanCapital">
            <a [routerLink]="['/admin/human-capital']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute( 'header.workforce')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.workforce' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.SetupInventory">
            <a [routerLink]="['/admin/inventory-setup']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.inventory_setup')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.inventory_setup' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.SetupFacility">
            <a [routerLink]="['/admin/facility-setup']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.facility_setup')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.facility_setup' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.Administration">
            <a [routerLink]="['/admin/administration']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.administration')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.administration' | translate }}
            </a>
          </div>
          
           <div class="dropdown_item" appAccessControl [accessRoles]="actions.TaskManagementList">
            <a [routerLink]="['/admin/task-management']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.task_management')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.task_management' | translate }}
            </a>
          </div>
         
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.SiteSecurity">
            <a [routerLink]="['/admin/gate-management']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.gate_management')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.gate_management' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.SystemSettings">
            <a [routerLink]="['/admin/settings-setup']" [routerLinkActive]="'active'"
              (click)="changeActiveRoute('header.setup_settings')" #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.setup_settings' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.ReportList">
            <a [routerLink]="['/reports']" [routerLinkActive]="'active'" (click)="changeActiveRoute('header.reports')"
              #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{ 'header.reports' | translate }}
            </a>
          </div>
          <div class="dropdown_item" appAccessControl [accessRoles]="actions.IncidentMangagmentCreate">
            <a [routerLink]="['/admin/incidentManagment']" [routerLinkActive]="'active'" (click)="changeActiveRoute('header.incident_managment')"
              #navRoutes>
              <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe02b;"></span>
              {{'dashboard.helth_safety_and_environment'|translate}}
            </a>
          </div>

        </div>
      </div>
    </div>
    <div class="header-part-right">
      <div class="elementor-widget-container">
        <div class="action-bar-btn dropdown-container" appDropDown>
          <span (click)="openNotificationPanel()" class="dropdown-toggler not-after">
            <span class="action-bar-count">{{unSeenNotificationsCount}}</span>
            <img src="./assets/images/icons/notifications-icon.svg">
          </span>
          <div class="action-bar-panel dropdown-inner-menu" style="color:black;">
            <div class="dropdown_header">
              <h3>{{ 'header.notification' | translate }}</h3>
            </div>

            <div>
              <div class="action-bar-list">
                <div *ngFor="let notif of notificationsList">
                  <a>
                    <p class="title">{{notif.title}}</p>
                    <span class="date">{{notif.message}}</span>
                  </a>

                </div>
              </div>
              <div *ngIf='notifLoading' class="dataLoading py-1">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-widget-container">
        <div class="action-bar-btn m-0">
          <span (click)="showSideNav()" class="dropdown-toggler not-after">
            <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe0a6;"></span>
          </span>
        </div>
      </div>
      <div class="elementor-widget-container">
        <div class="action-bar-btn dropdown-container m-0" appDropDown>
          <span class="dropdown-toggler not-after">
            <span [ngSwitch]="language">
              <span *ngSwitchCase="'en'">
                English
              </span>
              <span *ngSwitchCase="'ar'">
                العربية
              </span>
              <span *ngSwitchDefault>
                English
              </span>
            </span>

            <span class="general_icon fs7" aria-hidden="true" data-icon="&#xe091;"></span>
          </span>

          <div class="dropdown-inner-menu">
            <div class="dropdown_item">
              <a (click)="changeLanguage('en')">
                English
              </a>
            </div>
            <div class="dropdown_item">
              <a (click)="changeLanguage('ar')">
                العربية
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-widget-container">
        <div *ngIf="currentUser" class="userAccount dropdown-container m-0" id="userAccountDrop" appDropDown>
          <div class="dropdown-toggler p-0 not-after">
            <div class="profile-image">
              <img *ngIf="currentUser.user.imagePath" [src]="currentUser.user.imagePath"
                (error)="currentUser.user.imagePath = ''" />
              <span *ngIf="!currentUser.user.imagePath" [innerHTML]="currentUser.user.fullName | shortName"></span>
            </div>
          </div>

          <div class="dropdown-inner-menu">
            <div class="dropdown_item" appAccessControl [accessRoles]="actions.MyProfile">
              <a [routerLink]="['/admin/myprofile']" >
                <svg width="14" height="17" viewBox="0 0 14 17">
                  <path id="my-profile-icon"
                    d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z"
                    fill="#999999" />
                </svg>{{ 'header.my_profile' | translate }}
              </a>
            </div>
            <div class="dropdown_item" appAccessControl [accessRoles]="actions.MyPrefereneces" >
              <a [routerLink]="['user-preferences']">
                <svg width="14" height="17" viewBox="0 0 14 17">
                  <path id="my-profile-icon"
                    d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z"
                    fill="#999999" />
                </svg>{{ 'header.my_preferences' | translate }}
              </a>
            </div>
            <div class="dropdown_item">
              <a (click)="logout()">
                <svg width="17.001" height="17.006" viewBox="0 0 17.001 17.006">
                  <path id="logout-icon"
                    d="M6223.19,12103h-13.4a1.815,1.815,0,0,1-1.8-1.808v-13.383a1.815,1.815,0,0,1,1.811-1.808h13.4a1.817,1.817,0,0,1,1.792,1.808v4.146l-1.659-1.559v-2.74h-13.687v13.575h13.687v-2.625l1.659-1.461v4.165a1.766,1.766,0,0,1-.529,1.267,1.69,1.69,0,0,1-1.123.43C6223.3,12103.006,6223.243,12103,6223.19,12103Zm-4.514-5.039,2.691-2.688h-9.562v-1.54h9.562l-2.691-2.691,1.167-1.169,4.52,4.629-4.52,4.629Z"
                    transform="translate(-6208 -12086)" fill="#999" />
                </svg>{{ 'header.sign_out' | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-sidenav-over *ngIf="openSideNav" [open]="openSideNav" (closeDetails)="closeSidenav($event)">
  <app-theme-customizer (closeDetails)="closeSidenav($event)">
  </app-theme-customizer>
</app-sidenav-over>